import { render, staticRenderFns } from "./RegistrationsList.vue?vue&type=template&id=122afe0a&scoped=true"
import script from "./RegistrationsList.vue?vue&type=script&lang=js"
export * from "./RegistrationsList.vue?vue&type=script&lang=js"
import style0 from "./RegistrationsList.vue?vue&type=style&index=0&id=122afe0a&prod&scoped=true&lang=css"
import style1 from "./RegistrationsList.vue?vue&type=style&index=1&id=122afe0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122afe0a",
  null
  
)

export default component.exports